import { publicHref } from '../lib/publicUrls';
import { Link } from 'react-router-dom';
import ProgramJourney from '../components/ProgramJourney';
import SEO from '../components/SEO';
import { MEDIA_SLOTS } from '../lib/mediaTruth';
import { ServiceHero } from '../components/ServiceHeader';
import './MassagePage.css';

const therapeuticOptions = [
  ['Sports Recovery', 'Elevate your performance with our sports recovery massage. Tailored techniques soothe tired muscles, reduce inflammation, and enhance mobility, promoting swift recovery for athletes. Maximize your potential with rejuvenating care.'],
  ['Deep Tissue', 'Experience profound relief with our deep tissue therapeutic massage. Targeted work reaches deeper muscle layers to alleviate tension and promote healing. Firm pressure releases knots for a rejuvenating and revitalizing experience.'],
  ['Pre-Natal Massage', 'Indulge in serenity with prenatal massage designed specifically for expecting mothers. Gentle, soothing techniques relieve pregnancy-related discomfort and promote relaxation for both mom and baby.'],
  ['Needs-Specific', 'Choose a massage tailored to your unique concerns. Our therapists customize techniques to provide targeted relief and a rejuvenating experience personalized for you.'],
];

const MassagePage = () => (
  <main className="dv-massage" data-testid="massage-page">
    <SEO
      title="Hydro, Sports, Pre-Natal & Therapeutic Massage"
      description="Looking for massage therapy in Brentwood, CA? Delta Valley offers HydroMassage and traditional massage options to melt away tension and promote wellness."
      keywords="massage therapy Brentwood, sports massage, deep tissue massage, prenatal massage, HydroMassage"
    />
    <ServiceHero
      id="massage-title"
      media={MEDIA_SLOTS.programsMassage}
      disclosure="P06 program photography: pending approval · live text identity used · held from production"
      haze="106 152 130"
      current="Massage Therapy"
      label="Relieve tension. Support well-being."
      title={<><span>Relieve tension.</span><em>Support well-being.</em></>}
      lede="Personalized therapeutic massage and HydroMassage options to help relieve tension and support total well-being."
      actions={<>
        <a className="dv-button dv-button--light" href="#massage-inquiry">Book Now</a>
        <a className="dv-button dv-button--outline-light" href="#massage-services">Explore the Options</a>
      </>}
      facts={["Therapeutic massage", "HydroMassage", "Personalized to you"]}
    />

    <section className="dv-massage__therapeutic" id="massage-services" aria-labelledby="massage-therapeutic-title">
      <div className="dv-massage__section-introduction">
        <p className="dv-eyebrow dv-eyebrow--dark">01 · Therapeutic care</p>
        <h2 className="dv-size-heading" id="massage-therapeutic-title">Therapeutic Massage</h2>
        <p className="dv-size-body">
          Escape the stress and tension with our therapeutic massages, a relaxing
          retreat after a demanding day at work or the gym. Select from a diverse
          range of techniques tailored to alleviate pain and meet your wellness goals.
          Immerse yourself in tranquility, where relaxation meets personalized care.
          Your rejuvenation begins here.
        </p>
      </div>
      <ol className="dv-massage__service-ledger">
        {therapeuticOptions.map(([title, text], index) => (
          <li className="dv-size-body" key={title}>
            <span className="dv-massage__number" aria-hidden="true">0{index + 1}</span>
            <div><h3 className="dv-size-subheading">{title}</h3><p className="dv-size-body">{text}</p></div>
          </li>
        ))}
      </ol>
    </section>

    <section className="dv-massage__hydro" aria-labelledby="massage-hydro-title">
      <div className="dv-massage__section-introduction">
        <p className="dv-eyebrow">02 · HydroMassage</p>
        <h2 className="dv-size-heading" id="massage-hydro-title">HydroMassage</h2>
        <p className="dv-size-body">
          Experience pure relaxation in our massage chairs, a blend of soothing
          water jets and ergonomic design for a blissful massage that melts away
          tension and promotes muscle recovery and total well-being.
        </p>
      </div>
      <ul className="dv-massage__hydro-benefits">
        <li className="dv-size-body">
          <h3 className="dv-size-subheading">Targeted Muscle Relief</h3>
          <p className="dv-size-body">HydroMassage delivers precise muscle relief by directing pressurized water jets to specific areas, alleviating tension and promoting relaxation. Customize your experience for targeted comfort and rejuvenation.</p>
        </li>
        <li className="dv-size-body">
          <h3 className="dv-size-subheading">Enhances Recovery</h3>
          <p className="dv-size-body">Stimulate blood flow and reduce inflammation. Pressurized water jets promote healing and enhance overall recovery after physical activity.</p>
        </li>
      </ul>
    </section>

    <section className="dv-massage__closing" aria-labelledby="massage-closing-title">
      <div>
        <p className="dv-eyebrow dv-eyebrow--dark">Your next step</p>
        <h2 className="dv-size-heading" id="massage-closing-title">Relax and Rejuvenate Now!</h2>
        <p className="dv-size-body">Escape the stress and treat yourself with a massage today!</p>
      </div>
      <a className="dv-button dv-button--outline" href="#massage-inquiry">Book Now</a>
    </section>

    <ProgramJourney
      id="massage-inquiry" tone="sage" testId="massage-inquiry-journey"
      source="massage-interest"
      eyebrow="Let’s talk"
      title={['Ask About Massage', 'Your request, in about a minute.']}
      lede="Tell us what type of massage interests you and our team will follow up."
      note={<Link to={publicHref("/programs")}>All Programs</Link>}
      planTitle="Your massage request" request={['Program', 'Massage Therapy']}
      reviewNoun="massage request" startLabel="Start My Request" buttonText="Request Information"
      successTitle="Request Received"
      successMessage="Our team will contact you with massage options and next steps."
    />
  </main>
);

export default MassagePage;
